const Icons = {
  check: 'e900',
  checks: 'e901',
  activesessions: 'e902',
  add: 'e903',
  add_reaction: 'e904',
  addboost: 'e905',
  addmember_filled: 'e906',
  adduser: 'e907',
  admin: 'e908',
  ads: 'e909',
  align_center: 'e90a',
  align_left: 'e90b',
  align_right: 'e90c',
  animals: 'e90d',
  animations: 'e90e',
  app_expand: 'e90f',
  app_shrink: 'e910',
  archive: 'e911',
  arrow_down: 'e912',
  arrow_next: 'e913',
  arrow_prev: 'e914',
  arrowcircle: 'e915',
  arrowhead: 'e916',
  attach: 'e917',
  audio_repeat: 'e918',
  audio_repeat_single: 'e919',
  author_hidden: 'e91a',
  avatarnext: 'e91b',
  avatarprevious: 'e91c',
  aversion: 'e91d',
  back: 'e91e',
  binfilled: 'e91f',
  bold: 'e920',
  bomb: 'e921',
  boost: 'e922',
  boostcircle: 'e923',
  bot_filled: 'e924',
  botcom: 'e925',
  bots: 'e926',
  brightness: 'e927',
  brush: 'e928',
  bubblereply: 'e929',
  bug: 'e92a',
  calendar: 'e92b',
  calendarfilter: 'e92c',
  camera: 'e92d',
  cameraadd: 'e92e',
  captiondown: 'e92f',
  captionup: 'e930',
  car: 'e931',
  card: 'e932',
  card_outline: 'e933',
  cash_circle: 'e934',
  channel: 'e935',
  channel_filled: 'e936',
  channelviews: 'e937',
  chatspinned: 'e938',
  chatsplaceholder: 'e939',
  check1: 'e93a',
  checkbox: 'e93b',
  checkboxblock: 'e93c',
  checkboxempty: 'e93d',
  checkboxon: 'e93e',
  checkretract: 'e93f',
  checkround: 'e940',
  checkround_filled: 'e941',
  clock: 'e942',
  close: 'e943',
  clouddownload: 'e944',
  collapse: 'e945',
  colorize: 'e946',
  comments: 'e947',
  commentssticker: 'e948',
  contrast: 'e949',
  copy: 'e94a',
  crop: 'e94b',
  cross: 'e94c',
  crossgif: 'e94d',
  crossround: 'e94e',
  crossstar: 'e94f',
  crown: 'e950',
  darkmode: 'e951',
  data: 'e952',
  delete: 'e953',
  delete_filled: 'e954',
  deletedaccount: 'e955',
  deleteleft: 'e956',
  deleteuser: 'e957',
  devices: 'e958',
  document: 'e959',
  down: 'e95a',
  download: 'e95b',
  dragfiles: 'e95c',
  dragmedia: 'e95d',
  eats: 'e95e',
  edit: 'e95f',
  email: 'e960',
  endcall_filled: 'e961',
  enhance: 'e962',
  enter: 'e963',
  equalizer: 'e964',
  expand: 'e965',
  eye: 'e966',
  eye1: 'e967',
  eye2: 'e968',
  eyecross_outline: 'e969',
  factcheck: 'e96a',
  fade: 'e96b',
  fast_forward: 'e96c',
  fast_rewind: 'e96d',
  favourites: 'e96e',
  flag: 'e96f',
  flip: 'e970',
  flip_image_horizontal: 'e971',
  folder: 'e972',
  fontframe: 'e973',
  fontframe_bg: 'e974',
  fontframe_outline: 'e975',
  fontsize: 'e976',
  forward: 'e977',
  forward_filled: 'e978',
  free_transform: 'e979',
  fullscreen: 'e97a',
  gc_microphone: 'e97b',
  gc_microphoneoff: 'e97c',
  gem: 'e97d',
  gem_exchange: 'e97e',
  gem_transfer: 'e97f',
  geometric_digit_0: 'e980',
  geometric_digit_1: 'e981',
  geometric_digit_2: 'e982',
  geometric_digit_3: 'e983',
  geometric_digit_4: 'e984',
  geometric_digit_5: 'e985',
  geometric_digit_6: 'e986',
  geometric_digit_7: 'e987',
  geometric_digit_8: 'e988',
  geometric_digit_9: 'e989',
  geometric_dot: 'e98a',
  geometric_letter_x: 'e98b',
  gifs: 'e98c',
  gift: 'e98d',
  gift_premium: 'e98e',
  grain: 'e98f',
  group: 'e990',
  group_filled: 'e991',
  groupmedia: 'e992',
  groupmediaoff: 'e993',
  hand: 'e994',
  help: 'e995',
  hide: 'e996',
  highlights: 'e997',
  image: 'e998',
  image_original: 'e999',
  info: 'e99a',
  info2: 'e99b',
  italic: 'e99c',
  key: 'e99d',
  keyboard: 'e99e',
  lamp: 'e99f',
  language: 'e9a0',
  largepause: 'e9a1',
  largeplay: 'e9a2',
  left: 'e9a3',
  limit_chat: 'e9a4',
  limit_chats: 'e9a5',
  limit_file: 'e9a6',
  limit_folders: 'e9a7',
  limit_link: 'e9a8',
  limit_pin: 'e9a9',
  link: 'e9aa',
  link_paid: 'e9ab',
  list: 'e9ac',
  listscreenshare: 'e9ad',
  livelocation: 'e9ae',
  location: 'e9af',
  lock: 'e9b0',
  lockoff: 'e9b1',
  loginlogodesktop: 'e9b2',
  loginlogomobile: 'e9b3',
  logout: 'e9b4',
  mac_command_key: 'e9b5',
  mediaspeed_empty: 'e9b6',
  mediaspoiler: 'e9b7',
  mediaspoileroff: 'e9b8',
  mention: 'e9b9',
  menu: 'e9ba',
  message: 'e9bb',
  message_jump: 'e9bc',
  message_quote: 'e9bd',
  messageunread: 'e9be',
  microphone: 'e9bf',
  microphone_crossed: 'e9c0',
  microphone_crossed_filled: 'e9c1',
  microphone_filled: 'e9c2',
  minus: 'e9c3',
  monospace: 'e9c4',
  more: 'e9c5',
  multistories: 'e9c6',
  mute: 'e9c7',
  muted: 'e9c8',
  mynotes: 'e9c9',
  newchannel: 'e9ca',
  newchannel_filled: 'e9cb',
  newchat_filled: 'e9cc',
  newgroup: 'e9cd',
  newgroup_filled: 'e9ce',
  newprivate: 'e9cf',
  newprivate_filled: 'e9d0',
  newtab: 'e9d1',
  next: 'e9d2',
  nochannel: 'e9d3',
  noncontacts: 'e9d4',
  nosound: 'e9d5',
  online: 'e9d6',
  passwordoff: 'e9d7',
  pause: 'e9d8',
  permissions: 'e9d9',
  person: 'e9da',
  phone: 'e9db',
  phone_filled: 'e9dc',
  pin: 'e9dd',
  pin2: 'e9de',
  pinlist: 'e9df',
  pinned_filled: 'e9e0',
  pinnedchat: 'e9e1',
  pip: 'e9e2',
  play: 'e9e3',
  playback_05: 'e9e4',
  playback_15: 'e9e5',
  playback_1x: 'e9e6',
  playback_2x: 'e9e7',
  plus: 'e9e8',
  plusround: 'e9e9',
  poll: 'e9ea',
  premium_addone: 'e9eb',
  premium_avatars: 'e9ec',
  premium_badge: 'e9ed',
  premium_colors: 'e9ee',
  premium_double: 'e9ef',
  premium_emoji: 'e9f0',
  premium_filesize: 'e9f1',
  premium_lastseen: 'e9f2',
  premium_limits: 'e9f3',
  premium_lock: 'e9f4',
  premium_management: 'e9f5',
  premium_noads: 'e9f6',
  premium_privacy: 'e9f7',
  premium_reactions: 'e9f8',
  premium_restrict: 'e9f9',
  premium_speed: 'e9fa',
  premium_status: 'e9fb',
  premium_stickers: 'e9fc',
  premium_tags: 'e9fd',
  premium_transcription: 'e9fe',
  premium_translate: 'e9ff',
  premium_unlock: 'ea00',
  premium_wallpaper: 'ea01',
  previous: 'ea02',
  promote: 'ea03',
  quote: 'ea04',
  quote_outline: 'ea05',
  radiooff: 'ea06',
  radioon: 'ea07',
  reactions: 'ea08',
  reactions_filled: 'ea09',
  readchats: 'ea0a',
  recent: 'ea0b',
  redo: 'ea0c',
  replace: 'ea0d',
  reply: 'ea0e',
  reply_filled: 'ea0f',
  restrict: 'ea10',
  revenue: 'ea11',
  rightpanel: 'ea12',
  rotate: 'ea13',
  rotate_left: 'ea14',
  rotate_right: 'ea15',
  round_chats_filled: 'ea16',
  saturation: 'ea17',
  saved: 'ea18',
  savedmessages: 'ea19',
  schedule: 'ea1a',
  scheduled: 'ea1b',
  search: 'ea1c',
  select: 'ea1d',
  send: 'ea1e',
  send2: 'ea1f',
  sending: 'ea20',
  sendingerror: 'ea21',
  settings: 'ea22',
  settings_clipped_corner: 'ea23',
  settings_filled: 'ea24',
  shadows: 'ea25',
  sharescreen_filled: 'ea26',
  sharpen: 'ea27',
  shipping: 'ea28',
  shuffle: 'ea29',
  smallscreen: 'ea2a',
  smile: 'ea2b',
  speaker: 'ea2c',
  speakerfilled: 'ea2d',
  speakeroff: 'ea2e',
  speakerofffilled: 'ea2f',
  spoiler: 'ea30',
  sport: 'ea31',
  star: 'ea32',
  star_filled: 'ea33',
  statistics: 'ea34',
  stickers: 'ea35',
  stickers_face: 'ea36',
  stop: 'ea37',
  stories: 'ea38',
  storyreply: 'ea39',
  storyrepost: 'ea3a',
  strikethrough: 'ea3b',
  tag: 'ea3c',
  tag_add: 'ea3d',
  tag_alt: 'ea3e',
  tag_crossed: 'ea3f',
  tag_filter: 'ea40',
  tag_name: 'ea41',
  text: 'ea42',
  textedit: 'ea43',
  timer: 'ea44',
  tip: 'ea45',
  tools: 'ea46',
  topics: 'ea47',
  trade: 'ea48',
  transcribe: 'ea49',
  unarchive: 'ea4a',
  unclaimed: 'ea4b',
  underline: 'ea4c',
  undo: 'ea4d',
  unmute: 'ea4e',
  unpack: 'ea4f',
  unpin: 'ea50',
  unread: 'ea51',
  up: 'ea52',
  user: 'ea53',
  username: 'ea54',
  videocamera: 'ea55',
  videocamera_crossed_filled: 'ea56',
  videocamera_filled: 'ea57',
  videochat: 'ea58',
  vignette: 'ea59',
  volume_down: 'ea5a',
  volume_mute: 'ea5b',
  volume_off: 'ea5c',
  volume_up: 'ea5d',
  warmth: 'ea5e',
  webview: 'ea5f',
  win_key: 'ea60',
  zoomin: 'ea61',
  zoomout: 'ea62'
};

export default Icons;
